module.exports = __webpack_public_path__ + "static/gallery_treehouse_2-ee56aa5ef52b2cb3cc088d3611db210b.jpg";